import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

interface LayoutState {
  asideBarOpened: boolean;
  setAsideBarOpened: (asideBarOpened: boolean) => void;
}

export const useLayoutStore = create<LayoutState>()(
  devtools(
    persist(
      (set) => ({
        asideBarOpened: false,
        setAsideBarOpened: (asideBarOpened: boolean) => {
          set(() => ({ asideBarOpened: asideBarOpened }));
        },
      }),
      {
        name: "layout-storage",
      }
    )
  )
);
